import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import { RoundedButton } from "../../../components/ui/roundButton"

const DeleteCategoryModal = ({ open, onClose, onConfirm, item }) => {
  if (!open) return null

  return (
    <DefaultModal
      open={open}
      handleClose={onClose}
      title="Excluir categoria"
      contentDescription={
        <span>
          Deseja excluir <strong>{item?.name ?? ""}</strong>?
        </span>
      }
      maxWidth="xs"
      action={
        <div style={{ display: "flex", gap: 12 }}>
          <RoundedButton rounded="outlined" onClick={onClose} sx={{ flex: 1, whiteSpace: "nowrap" }}>
            Cancelar
          </RoundedButton>
          <RoundedButton
            onClick={() => onConfirm(item)}
            sx={{ flex: 1, whiteSpace: "nowrap" }}
          >
            Sim, excluir
          </RoundedButton>
        </div>
      }
    />
  )
}

export default DeleteCategoryModal
